import { useState, useEffect } from 'react';
import { FiltersDrawer } from './FiltersDrawer';
import { FilterPropertiesPanelContent } from './FilterPropertiesPanelContent';
import { cloneDeep, get } from 'lodash';
import { deepMerge } from '../../../../../utils/deepMerge';
import { Heading, Button } from '@appd/uik';

// we will need filter var in the option section as well

// input : filterJSONS
// output: filterJSONS; selectedTemplateName

export const FiltersConfigPanel = ({ templates, updateTemplates, updateSelectedTemplateName }: any): JSX.Element => {
  const [filterTemplates, setFilterTemplates] = useState<Record<string, any>[]>(templates);
  const [panelName, setPanelName] = useState<any>('Filter Properties');
  const [varMap, setVarMap] = useState<any[]>([]);
  const [selectedFilterIndex, setSelectedFilterIndex] = useState<number | undefined>(undefined);
  const [selectedFilterJSON, setSelectedFilterJSON] = useState<Record<string, any>>();
  const [propsJSON, setPropsJSON] = useState<any>();

  useEffect(() => {
    extractVars(filterTemplates);
  }, [filterTemplates]);

  useEffect(() => {
    if (selectedFilterIndex !== undefined) {
      const selectedTemplate = filterTemplates[selectedFilterIndex];
      updateSelectedTemplateName(selectedTemplate?.name ?? '');
      setSelectedFilterJSON(cloneDeep(selectedTemplate));
      setPropsJSON(cloneDeep(get(selectedTemplate, 'spec.props', {})));
    }
  }, [selectedFilterIndex, filterTemplates, updateSelectedTemplateName]);

  useEffect(() => {
    console.log('selected Filter Index Update');
    console.log(selectedFilterIndex);
  }, [selectedFilterIndex]);

  const extractVars = (filterJSONS: any[]) => {
    const map: any[] = [];
    filterJSONS.map((filterJSON: any) => {
      map.push({ varName: (filterJSON.spec?.props?.component?.props?.varName as string) ?? '' });
    });
    setVarMap([...map]);
  };

  const onSelectFilter = (index: number) => {
    setSelectedFilterIndex(index);
  };

  const onUpdateProps = (newFilterTemplateProps: Record<string, any>) => {
    const updatedFilterTemplateProps = deepMerge({}, newFilterTemplateProps, propsJSON);
    const updatedFilterTemplateJSON = deepMerge(
      {},
      { spec: { props: updatedFilterTemplateProps } },
      selectedFilterJSON,
    );

    const updatedFilterTemplateJSONs = [...filterTemplates];
    updatedFilterTemplateJSONs[selectedFilterIndex as number] = updatedFilterTemplateJSON;
    setFilterTemplates(updatedFilterTemplateJSONs);
    updateTemplates(updatedFilterTemplateJSONs);
  };

  const navBackToDrawer = () => {
    setSelectedFilterIndex(undefined);
  };

  return (
    <>
      {selectedFilterIndex !== undefined && (
        <div>
          <div className="flex flex-row items-center">
            <Button type="TERTIARY" icon="Navigation.ChevronLeft" onClick={navBackToDrawer} />
            <Heading size="PRIMARY">{varMap[selectedFilterIndex].varName}</Heading>
          </div>
          <FilterPropertiesPanelContent widget={propsJSON} updateWidget={onUpdateProps}></FilterPropertiesPanelContent>
        </div>
      )}
      {selectedFilterIndex === undefined && (
        <div>
          <div className="flex flex-row items-center justify-between">
            <Heading size="PRIMARY">Filter Properties</Heading>
          </div>
          <FiltersDrawer vars={varMap} onSelectFilter={onSelectFilter}></FiltersDrawer>
        </div>
      )}
    </>
  );
};
